export default __webpack_public_path__ + "static/DIN-Pro-Bold-3df1215e7e10ac112c852403b8ec0f30.woff";